import { render, staticRenderFns } from "./settingsControl.vue?vue&type=template&id=4a8c16ef&scoped=true&"
import script from "./settingsControl.vue?vue&type=script&lang=js&"
export * from "./settingsControl.vue?vue&type=script&lang=js&"
import style0 from "./settingsControl.vue?vue&type=style&index=0&id=4a8c16ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c16ef",
  null
  
)

component.options.__file = "settingsControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
  VFlex,
})
